export default __webpack_public_path__ + "static/media/heist-background.1ca1fbf6.jpeg";